<script lang="ts">
  import DatePanelHeaderSkeleton from "./DatePanelHeaderSkeleton.svelte";
</script>

<div class="container">
  <div class="header">
    <DatePanelHeaderSkeleton />
  </div>

  <div class="invoice-image" />
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 16px;
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-color: var(--rekki-light);
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .invoice-image {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 70vh;
    overflow: hidden;
    background-color: var(--rk-neutral-0);
    border: solid 1px var(--rk-divider-0);
    border-radius: 8px;
    padding: 16px;
    margin: 16px 0;
  }
</style>
